import React, { useState } from "react";
import { Grid, Paper } from "@material-ui/core";
import Chart from "react-apexcharts";
import { stateChart } from "../../../utils/stateChart";
import { SEX } from "../../../utils/constants";

const initialState = stateChart([SEX.HOMBRE, SEX.MUJER]);

const ReportByGenr = ({ data }) => {
  const [state] = useState(initialState);
  let usersp;
  let sex;

  const quantityUserByProjectsH = () => {
    const res = data
      .filter((project) => project.users.length >= 1)
      .map((filteredPerson) => filteredPerson.users);
    usersp = res.flat();
    sex = usersp.filter((project) => project.sex === SEX.HOMBRE);
    return sex.length;
  };

  const quantityUserByProjectsM = () => {
    const res = data
      .filter((project) => project.users.length >= 1)
      .map((filteredPerson) => filteredPerson.users);
    usersp = res.flat();
    sex = usersp.filter((project) => project.sex === SEX.MUJER);
    return sex.length;
  };

  return (
    <Grid item xs={8} sm={8} md={12}>
      <Paper className="paper" style={{ marginTop: "2em" }}>
        <Chart
          options={state.options}
          series={[quantityUserByProjectsH(), quantityUserByProjectsM()]}
          type="pie"
          height={380}
          className="chart"
        />
      </Paper>
    </Grid>
  );
};

export default ReportByGenr;
